// Tiny inline-SVG sparkline. No chart-lib dep. Accepts a number[] and an
// optional `tone` ("ok"/"warn"/"err"/"info").
import React from "react";
import colors from "../../../../../utils/colors";

const TONES = {
  ok:   "#10b981",
  warn: "#f59e0b",
  err:  "#ef4444",
  info: colors?.primary?.[500] || "#6371F7",
  neutral: "#9ca3af",
};

export default function Sparkline({ data = [], width = 96, height = 28, tone = "info", strokeWidth = 1.5 }) {
  if (!Array.isArray(data) || data.length < 2) {
    return <svg width={width} height={height} aria-hidden="true" />;
  }
  const min = Math.min(...data);
  const max = Math.max(...data);
  const range = max - min || 1;
  const stepX = width / (data.length - 1);
  const points = data.map((v, i) => `${i * stepX},${height - ((v - min) / range) * height}`).join(" ");
  const stroke = TONES[tone] || TONES.info;
  // soft fill under the line (shaded area)
  const area = `0,${height} ${points} ${width},${height}`;
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="none" aria-hidden="true">
      <polygon points={area} fill={stroke} fillOpacity="0.1" />
      <polyline points={points} fill="none" stroke={stroke} strokeWidth={strokeWidth} strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
}
